import {type TabsProps, Grid} from '@logistics-frontend/blocks'
import {useFormContext} from '@yandex-delivery/form'
import {useCallback, useState} from 'react'

import {Badge} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'
import {OrderEventGoal, useFormUserEventHandler} from 'src/shared/hooks'
import {DestinationPointDeliveryMethod} from 'src/shared/types'
import {orderPath} from 'src/shared/utils'

import type {Props} from '../types'
import {isDestinationPointDeliveryMethod} from '../utils'

export function useDestinationPointNdd(props: Props) {
  const {name} = props
  const {watch, setFieldValue} = useFormContext()
  const [isBannerVisible, setIsBannerVisible] = useState(false)
  const isBusiness = watch(orderPath('isBusiness'))
  const handleReachGoal = useFormUserEventHandler()

  const toggleBannerVisibilityHandler = useCallback(() => {
    setIsBannerVisible(prev => !prev)
  }, [])

  const handleDeliveryMethodChange = useCallback(
    (value: string) => {
      if (value === DestinationPointDeliveryMethod.Address) {
        toggleBannerVisibilityHandler()
        handleReachGoal(OrderEventGoal.B2BDeliveryTypeD2DClick)
        return
      }

      if (isDestinationPointDeliveryMethod(value)) {
        setFieldValue(`${name}._deliveryMethod`, value)
      }
    },
    [handleReachGoal, name, setFieldValue, toggleBannerVisibilityHandler],
  )

  function handleBannerActionButtonClick() {
    handleReachGoal(OrderEventGoal.BannerD2DButtonClick)
  }

  return {
    isBannerVisible,
    toggleBannerVisibilityHandler,
    handleDeliveryMethodChange,
    orderNumber: 1,
    tabs: isBusiness ? tabs : undefined,
    handleBannerActionButtonClick,
  } as const
}

const tabs: TabsProps<string>['items'] = [
  {
    label: (
      <Grid alignItems="center" justify="center" size="xs" container>
        <Grid item>{i18n('ndd.delivery_policy.time_interval.title.mobile', 'До двери')}</Grid>
        <Grid item>
          <Badge label={i18n('form.order.badge.business', 'Бизнес')} isDisabled />
        </Grid>
      </Grid>
    ),
    value: DestinationPointDeliveryMethod.Address,
  },
  {
    label: i18n('ndd.delivery_policy.self_pickup.title.mobile', 'В пункт выдачи'),
    value: DestinationPointDeliveryMethod.PickUpPoint,
  },
]
